/* eslint-disable no-unused-vars */
import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { useGetUserCertificationsByCpf } from '../../hooks/certificado';
import { Card } from '../../components/shared/card/card';
import { StyledJumbotron } from '../../components/shared/jumbotron/jumbotron-styled';
import { PRODUTO_ENDPOINT } from '../../hooks/constants';
import CardBackgroundImage from '../../assets/card-background.png';
import CertificadoNotFoundImage from '../../assets/certificados.svg';
import {
  BaSeContainer,
  BaSeDialogContext,
  BaSeHeading1,
  BaSeHeading2,
  BaSeHeading4,
  BaSeInput,
  BaSeLoading,
  BaSeLoadingPage,
  BaSeParagraph,
  BaSeSelect,
  BaSeTheme,
} from '@base/react';
import {
  ContainerPadding,
  GridContent,
  NoContentContainer,
  SeachInputContainer,
  SearchContainer,
  SearchSelectInput,
} from './certificados-styled';

const filterTypes = ['DATA_FIM', 'NOME_CURSO'];
const CERTIFICADOS_URL_MORE =
  'https://ava.sebrae.com.br/Portal/Modules/Certified/CertifiedModal.asp?history=s';

const handleBlob = (blob) => {
  if (!blob) {
    return null;
  }
  const objectURL = URL.createObjectURL(blob);
  return objectURL;
};

const handleCards = (ele, memo) => (
  <Card
    {...ele}
    key={ele?.id}
    image={handleBlob(memo[ele?.id]) ?? CardBackgroundImage}
  />
);

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Certificados = () => {
  const {
    keycloak: { tokenParsed },
    isInitialized,
    isAuthenticated,
    login,
  } = Sebrae.useAuth();
  const { backendGetBlob } = Sebrae.useBackend();

  const [busca, setBusca] = React.useState('');
  const [buscaAux, setBuscaAux] = React.useState('');
  const [orderBy, setOrderBy] = React.useState(filterTypes[0]);
  const { showNotification } = React.useContext(BaSeDialogContext);
  const [memo, setMemo] = React.useState({});
  const [othersCursos, setOthersCursos] = React.useState([]);
  const [categoryCurso, setCategoryCurso] = React.useState([]);
  const [typeCursos, setTypeCursos] = React.useState([]);

  const handleChangeSelect = (val) => {
    if (val?.id) {
      setOrderBy(filterTypes[val.id - 1]);
    }
  };

  const [cursos, loading, error] = useGetUserCertificationsByCpf(
    tokenParsed?.cpf?.replace(/\D/g, ''),
    orderBy,
    busca,
  );

  React.useEffect(() => {
    const others = cursos?.filter((e) => {
      return (
        e.tipoProduto === null || e.tipoProduto?.toLowerCase() === 'outros'
      );
    });
    setOthersCursos(others);

    const categories = [];

    const categorized = cursos?.filter(
      (e) => e.tipoProduto !== (null && 'Outros'),
    );
    setTypeCursos(categorized);

    const maped = categorized?.map((e) => categories.push(e.tipoProduto));

    const uniqueCategory = categories?.filter((e, i) => {
      return categories.indexOf(e) === i;
    });
    setCategoryCurso(uniqueCategory);
  }, [cursos]);

  React.useEffect(() => {
    if (error && isInitialized && isAuthenticated) {
      showNotification({
        message: 'Erro ao buscar certificados',
        color: 'destructive',
      });
    }
  }, [error, showNotification, isInitialized, isAuthenticated]);

  React.useEffect(() => {
    if (isInitialized && cursos) {
      cursos.forEach((curso) => {
        if (!!curso?.idProduto) {
          backendGetBlob(
            `${PRODUTO_ENDPOINT}/${curso?.idProduto}/CARD/imagem`,
          ).then((data) => {
            setMemo((prev) => ({ ...prev, [curso?.id]: data }));
          });
        }
      });
    }
  }, [cursos, backendGetBlob, isInitialized]);

  if (!isInitialized) {
    return <BaSeLoadingPage />;
  }

  if (isInitialized && !isAuthenticated) {
    login();
    return <BaSeLoadingPage />;
  }

  return (
    <div>
      <StyledJumbotron
        backgroundColor={BaSeTheme.colors.institucionais.azulSebrae97}
      >
        <BaSeHeading1 color={BaSeTheme.colors.institucionais.azulSebrae30}>
          Certificados Sebrae
        </BaSeHeading1>
        <BaSeHeading4 color={BaSeTheme.colors.institucionais.azulSebrae30}>
          Meus certificados
        </BaSeHeading4>
      </StyledJumbotron>
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <ContainerPadding>
          <SearchContainer>
            <SeachInputContainer>
              <BaSeInput
                isDisabled={loading}
                iconButton={{
                  action: () => setBusca(buscaAux),
                  color: 'default',
                  name: 'search',
                  type: 'tertiary',
                  typeButton: 'base-shape-button',
                }}
                inputMode="text"
                placeholder="Pesquisar"
                size="medium"
                typeInput="text"
                value={buscaAux}
                onChange={setBuscaAux}
                width="100%"
                onSpecificKeyDown={[
                  { listenerKey: 'Enter', callback: () => setBusca(buscaAux) },
                ]}
              />
            </SeachInputContainer>
            <SearchSelectInput>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              >
                Ordenar por
              </BaSeParagraph>
              <BaSeSelect
                isDisabled={loading}
                emptyValueLabel=""
                onChange={handleChangeSelect}
                selectedValueId={1}
                size="medium"
                subLabel=""
                values={[
                  {
                    id: 1,
                    label: 'Data de conclusão',
                  },
                  {
                    id: 2,
                    label: 'Nome do certificado',
                  },
                ]}
              />
            </SearchSelectInput>
          </SearchContainer>
          {loading && (
            <BaSeLoading
              backgroundColor="rgba(255,255,255,0)"
              description=""
              lightMode="default"
              progress={null}
              shadowLevel={0}
              spinnerColor="default"
              spinnerSize={48}
              text="Buscando certificados..."
              textColor=""
            />
          )}
          {!!cursos?.length && !loading && (
            <>
              {!!categoryCurso.length &&
                categoryCurso?.map((tipo, index) => {
                  return (
                    tipo.toLowerCase() !== 'outros' && (
                      <>
                        <BaSeHeading2 key={index}>{tipo}</BaSeHeading2>
                        <GridContent>
                          {typeCursos.map((ele) => {
                            return (
                              ele.tipoProduto === tipo && handleCards(ele, memo)
                            );
                          })}
                        </GridContent>
                      </>
                    )
                  );
                })}
              {!!othersCursos.length && (
                <>
                  <BaSeHeading2>Outras soluções</BaSeHeading2>
                  <GridContent>
                    {othersCursos.map((ele) => (
                      <Card
                        {...ele}
                        key={ele?.id}
                        image={handleBlob(memo[ele?.id]) ?? CardBackgroundImage}
                      />
                    ))}
                  </GridContent>
                </>
              )}
            </>
          )}
          {!cursos?.length && !loading && (
            <NoContentContainer>
              <BaSeHeading4
                isBold
                color={BaSeTheme.colors.institucionais.azulSebrae36}
              >
                Você ainda não tem nenhum certificado emitido
              </BaSeHeading4>
              <img
                src={CertificadoNotFoundImage}
                alt="certificados não encontrados"
              />
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.azulSebrae36}
              >
                Nesse ambiente você só terá acesso a alguns certificados, ainda
                não migramos todos. Verifique outros certificados emitidos{' '}
                <a
                  href={CERTIFICADOS_URL_MORE}
                  rel="nofollow noreferrer noopener"
                  target="_blank"
                >
                  clicando aqui
                </a>
              </BaSeParagraph>
            </NoContentContainer>
          )}
        </ContainerPadding>
      </BaSeContainer>
    </div>
  );
};
